export default {
  general: {
    loading: 'Loading',
    understood: 'Got it',
    attention: 'Attention!',
    edit: 'Edit',
    save: 'Save',
    delete: 'Delete',
    cancel: 'Cancel',
    abandon: 'Abandon',
    proceed: 'Proceed',
    editInformation: 'Edit Information',
    editLocation: 'Edit Location',
    editDetail: 'Edit Details',
    editValue: 'Edit Values',
    whoops: 'Whoops...',
    verified: 'Verified',
    negotiates: 'Negotiates',
    return: 'Return',
    rent: 'Rent',
    dueDate: 'Due date',
    condominium: 'Condominium',
    iptu: 'IPTU',
    sectionTitles: {
      location: 'Location',
      propertyDetails: 'Property Details',
      condominiumDetails: 'Condominium Details',
      responsible: 'Responsible',
      propertyValues: 'Property Values',
    },
    mainTabs: {
      rent: 'Rent',
      announcement: 'Announce',
      manage: 'Manage',
      profile: 'Profile',
    },
    formErrors: {
      missingField: '{{missingField}} form field is mandatory.',
    },
    seeProfile: 'See Profile',
    deniedCredit: 'Credit denied',
    seeOffer: 'Visualize Proposal',
    month: {
      jan: 'Jan',
      feb: 'Feb',
      mar: 'Mar',
      apr: 'Apr',
      may: 'May',
      jun: 'Jun',
      jul: 'Jul',
      aug: 'Aug',
      sep: 'Sep',
      oct: 'Oct',
      nov: 'Nov',
      dec: 'Dec',
    },
    months: {
      zero: 'months',
      one: 'month',
      other: 'months',
    },
    years: {
      zero: 'years',
      one: 'year',
      other: 'years',
    },
    contact: 'Contact',
    moment: {
      fullDate: 'YYYY MM DD',
    },
    error: 'There whas an error. ',
    technicalDetails: 'Technical Details: ',
  },
  report: {
    irregularities: 'Irregularities in this announcement?',
    button: 'Report',
  },
  shared: {
    profileView: {
      commonFriendsTitle: 'Common Friends',
      commonFriendsSubtitle: 'You have friends in common.',
      commonInterestsTitle: 'Interests',
      commonInterestsSubtitle: 'You have common interests.',
      socialMediaTitle: 'Social Media',
      socialMediaSubtitle: 'Check out the main social medias of this user',
      contact: "If you're interested in contacting {{userName}} just access your contacts.",
    },
  },
  helpers: {
    image: {
      options: {
        takePhoto: 'Take Photo',
        pickFromGallery: 'Choose from Gallery',
      },
      cameraAndGalleryDenied:
        'Permission to use camera and/or gallery was denied. To use this feature, ' +
        'please go to System preferences and enable this permission.',
    },
    announcement: {
      alertLandlord:
        'Unfortunately it is currently not possible to contact this tenant ' +
        'because he/she has not informed a Whatsapp number.',
      alertRent:
        'Unfortunately it is currently not possible to contact this landlord ' +
        'because he/she has not informed a Whatsapp number.',
      wppLinkingError:
        'Could not open Whatsapp. Make sure you have it installed and try again later.',
    },
  },
  conditions: {
    header: 'Conditions',
    mainText: 'Business conditions are established by the landlord and may be open to negociation.',
    bankDeposit: 'Bank Deposit',
    insuranceBond: 'Insurance Bond',
  },
  components: {
    detailRowProperty: 'Property Detail',
    propertyOwner: 'Property Owner',
    infoRowHouse: 'house',
    infoRowType: 'type',
    infoRowArea: 'area',
    infoRowBathrooms: 'bathroom',
    infoRowRooms: 'rooms',
    infoRowGarage: 'car slots',
    valuesRowRent: 'Rent',
    valuesRowCondominium: 'Condominium',
    valuesRowIPTU: 'IPTU',
    valuesRowOthers: 'Others',
    valuesTotal: 'total:',
    noConnection: 'No Internet Connection',
    noConnectionOffline:
      'The system is offline, please check your internet connection and try again',
    noConnectionButton: 'Try Again',
    announcementMapSummary: {
      apartment: 'Apartment',
      house: 'House',
      studio: 'Studio',
      rentValue: 'Rent',
      totalValue: 'Total',
    },
    propertyDetail: {
      penthouseApartment: 'Penthouse Apartment',
      cabinetsInTheKitchen: 'Cabinets in the kitchen',
      cabinetsInTheBathroom: 'Cabinets in the bathroom',
      airConditioning: 'Air Conditioning',
      whirlpoolBathtub: 'Whirlpool Bathtub',
      serviceBathroom: 'Service Bathroom',
      stove: 'Stove',
      refrigeratorIncluded: 'Refrigerator',
      garden: 'Garden',
      gourmetBalcony: 'Gourmet Balcony',
      serviceRoom: 'Service Room',
      pool: 'Pool',
      barbecue: 'Barbecue',
      petFriendly: 'Pet Friendly',
      extraReversibleRoom: 'Extram Reversible Room',
      glassBox: 'Glass Box',
      gasShower: 'Gas Shower',
      bedroomCloset: 'Closet in Bedrooms',
      bed: 'Bed',
      sofa: 'Sofa',
      washingMachine: 'Washing Machine',
      decoratedProperty: 'Decorated Property',
    },
    condominiumDetail: {
      gym: 'Gym',
      barbecue: 'Barbecue',
      elevator: 'Elevator',
      gourmetSpace: 'Gourmet space in the common area',
      laundry: 'Laundry in the building',
      pool: 'Pool',
      playground: 'Playground',
      concierge: '24h Concierge',
      sportsCourt: 'Sports Court',
      partyHall: 'Party Hall',
      sauna: 'Sauna',
    },
    propertyType: {
      title: 'Property Type',
      house: 'House',
      apartment: 'Apt',
      studio: 'Studio',
    },
  },
  tutorial: {
    announcement: {
      title: 'When register your property on Mellro:',
      firstText:
        'You can create an advertisement for your property for free and receive notifications ' +
        'about interested parties right on your mobile phone',
      secondText:
        'You can view the profile of the interested parties ' +
        'and select more securely the tenant of your dreams',
      thirdText: 'You can chat, negotiate and get in touch with your future tenant by Whatsapp',
    },
    catalog: {
      firstTitle: 'Our catalog is easy to use!',
      firstText:
        'You can right to like a property, and swipe left to remove it from your list! Easy, right?',
      secondTitle: 'Our catalog is easy to use!',
      secondText:
        "With just a Tap on the property's image you can see all the photos in the property's card.",
      thirdTitle: 'You can also search by the map!',
      thirdText: 'You can quickly find properties grouped by regions, using the map.',
      fourthTitle: "Or, if you prefer, there's also a list!",
      fourthText: "Do you prefer to seach on a list? No problems! We've got you covered.",
      fifthTitle: 'Liked a property?',
      fifthText:
        'Now you only need to wait for the property Owner to approve your profile. ' +
        'Then you can both negotiate.',
      buttonText: 'Go to Search',
    },
    manageOwner: {
      firstTitle: 'Manage your payments and contracts',
      firstText: 'Allows you to track rental payments.',
      secondTitle: 'Discounts and Additions',
      secondText: 'And you can also add new conditions on the open installments.',
      thirdTitle: 'Directly with the Tenant',
      thirdText: 'You can contact your tenant to ask questions.',
    },
    manageTenant: {
      firstTitle: 'Manage your payments and contracts',
      firstText: 'Allows you to track rentals, make payments, and manage the contract., .',
      thirdTitle: 'Directly with the Owner',
      thirdText: 'You can contact the owner to ask questions.',
    },
    help: {
      title: 'Need more help?',
      text: "If you still have any questions just ask it out. We'll be glad to help!",
      button: 'Ask for help',
    },
  },
  announcement: {
    registerMyProperty: 'Announce my property',
    buttonText: 'Next',
    photoUpload: {
      multipleUploadClose: 'Close',
      multipleUploadDone: 'Done',
      multipleUploadSelected: 'Selected',
      multipleUploadEmpty: 'Your gallery is empty',
      multipleUploadPick: 'Choose Multiple Photos',
      alertText:
        'The permissions for the camera and/or photo gallery were denied. ' +
        'To create an announcement, go to System Preferences and enable these permissions.',
      titleText: 'Add Photos',
      subtitleText: 'Select property photos that will compose your announcement',
      highlight: 'Highlight',
    },
    propertyAddress: {
      autocomplete: {
        address: 'Address',
        placeholder: 'Enter Address',
      },
      titleText: 'Property Address',
      subtitleText: 'Enter the property location you wish to rent',
      invalidZipcode: 'Zipcode is incomplete.',
      invalidState: 'State is incomplete.',
      invalidAddress:
        'It was not possible to find the address on the map. Please, review address data input.',
      zipCode: 'Zipcode',
      zipCodePlaceholder: 'Inform property zipcode',
      city: 'City',
      state: 'State',
      neighbourhood: 'Neighbourhood',
      street: 'Street',
      number: 'Number',
      numberPlaceholder: 'Property number',
      complement: 'Complement',
      complementPlaceholder: 'Apt-Number/Block/House',
    },
    propertyRefPoint: {
      refPoint: 'Reference Point',
      refPointPlaceholder: 'Insert a reference point close by the property',
    },
    propertyDetail: {
      titleText: 'Property Details',
      subtitleText: 'Detailing your property increases the chances of renting',
    },
    condominiumDetail: {
      titleText: 'Condominium Details',
      subtitleText: 'Detailing your property increases the chances of renting',
    },
    propertyInfo: {
      titleText: 'Property Information',
      subtitleText: 'Define the characteristics of your rental property',
      typeText: 'Type',
      areaText: 'Total area of the property',
      roomText: 'Room(s)',
      bathroomText: 'Bathroom(s)',
      carSlotText: 'Car Slot(s)',
    },
    propertyValues: {
      titleText: 'Property Values',
      subtitleText: 'Describe the values that make up the final value for renting your property',
      switchText: 'THE TENANT PAYS',
      placeholders: {
        rent: 'Enter the rent value',
        condominium: 'Enter the value of your condominium',
        iptu: 'Enter the value of your iptu',
        others: 'Enter the custom item value',
      },
      labels: {
        labelRent: 'Rent',
        labelCondominium: 'Condominium',
        labelIPTU: 'Monthly IPTU',
        labelOthers: 'Others',
      },
      rentZeroText: 'The rent value cannot be zero!',
      totalValueText: 'Total Value',
    },
    propertyConditions: {
      title: 'Guarantee',
      moreDetail: 'More Details',
      likeThat: 'Announced stays like this:',
      youGetMonthMoney: 'You get the whole month with:',
      titleText: 'Select an option for your contract and payment guarantee model!',
      bottomText: "Don't worry, you can change your warranty for every interested party!",
      component: {
        year: 'YEAR',
        creditalApprove: 'Depends on credit approval!',
        financialInsurance: 'FINANCIAL INSURANCE',
        withBill: 'WITH BULL',
        noGuarantor: "You don't need a guarantor",
      },
      depositBond: {
        title: 'DEPOSIT OF ENTRY',
        ManualReceipt: 'Manual Receipt',
        bankBillet: 'No Billet',
        monthsToDeposit: 'Up to 3 months to deposit',
        legalCovarage: 'Without legal coverage',
        chargeBy: ' The collection is made by the owner',
        assistance: 'No assistance',
        comission: 'No comission',
        threeMonths: '03 MONTHS',
        twoMonths: '02 MONTHS',
        oneMonth: '01 MONTH',
        noDeposit: 'WITHOUT CAUTION',
        guarantee: 'No guarantee of receipt',
        selectMonth: {
          title: 'Select how many collaterals equivalent to the amount of the rent',
          subtitle: 'No. of bonds',
          button: 'Confirm and continue',
        },
      },
      insuranceBond: {
        title: 'INSURANCE INCLUDED',
        automaticReceipt: 'Automated Receipt',
        bankBillet: 'With Boleto*',
        insurancePercent: '15% Insurance paid by the resident',
        legalCovarage: 'With Legal Coverage*',
        chargeBy: 'The insurance company charges in case of delay',
        assistance: '24h assistance for emergencies',
        comission: 'No fees, no comission',
        guarantor: 'No need for a guarantor',
        guarantee: '30 months guaranteed receipt of rent, condominium, IPTU and others*',
      },
      conditionDetails: {
        mellroAdvantagesTitle: 'MELLRO ADVANTAGES',
        finalValue: 'Final Value',
        numbers: {
          one: '01',
          two: '02',
          three: '03',
          four: '04',
          five: '05',
          six: '06',
          seven: '07',
          eight: '08',
          nine: '09',
          thirty: '30',
        },
        depositBond: {
          subtitle:
            'Surety is a form of security in contracts involving monetary values to secure ' +
            'the payment to the supplier. In this case, the object of the deposit no more ' +
            'is that the guarantee of performance of an obligation or contract.' +
            'Your objective in a rental contract is to reduce the risk of non-payment by the tenant.' +
            'Soon, in the breach of the rental contract with security,' +
            'the guarantee is called and the owner of the property is returned.',
          howWorks: 'how does it work?',
          canAsk: 'You can ask until:',
          depositMonths: 'months deposit',
          legalCovarage: 'No legal cover',
          chargeBy: 'The charge is made by the owner',
          assistance: 'No assistance',
          comission: 'No comission',
          threeMonths: '03 MONTHS',
          guarantee: 'No guarantee of receipt',
          mellroAdvantages: {
            subtitle:
              'By registering your property at Mellro you have advantages you never imagined!',
            dialog1: 'Free automated management',
            dialog2: 'With ticket and automatic receipt',
            dialog3: 'Contract with free electronic signature',
            dialog4: 'No Fees No Comission No Surprise',
          },
          ownersObligation: {
            title: 'OBLIGATIONS OF THE IMMOVABLE DONATION',
            dialog1: ' The value of the Bond returns to the Resident at the end of the contract',
            dialog2:
              'The Owner of the property is responsible for the collection of the monthly values' +
              "But don't worry, you'll be remembered by the Mellro management system.",
            dialog3: 'We offer a credit assessment tool, but we do not give the guarantee offered',
          },
          finalValue: {
            title: 'Final Value',
            subtitle:
              'The final Value of your ad is exactly what you defined during the creation of your ad',
            rentValue: 'Rent Value',
          },
        },
        insuranceBond: {
          subtitle:
            'One of the concerns as a property owner is to have security of receipt and find a good tenant. ' +
            'With bail insurance this concern no longer exists ' +
            'because all you have to do is choose the built-in bail insurance option ' +
            'and we will add 15% of the rent to be paid by the tenant',
          cover: 'COVERAGE',
          guarantee: 'months guaranteed',
          rent: 'Rent',
          condominium: 'Condominium',
          iptu: 'IPTU',
          water: 'Water',
          light: 'Light',
          gas: 'Gas',
          assistance: 'Assistance',
          Keyring: 'Keyring',
          Electrician: 'Electrician',
          Plumber: 'Plumber',
          whiteLine: 'White Line',
          mellroAdvantages: {
            subtitle:
              'By registering your property at Mellro you have advantages you never imagined!',
            dialog1: 'Free automatic management',
            dialog2: 'With boleto and automatic recubo',
            dialog3: 'Contract with free electronic signature',
            dialog4: 'No Fees No Comission No Surprise',
          },
          residentBenefits: {
            title: 'ADVANTAGES FOR THE DORATE',
            dialog1: 'End of the embarrassment in the search for a guarantor',
            dialog2: 'Insurance can be paid in installments',
            dialog3: '24 hour assistance for emergency repairs',
            dialog4: 'Discount on transportation of your move with affiliated carriers',
          },
          propertyOwnerBenefits: {
            title: 'ADVANTAGES FOR THE OWNERBENEFITS',
            dialog1: 'End of the risk of hiring professional Guarantors',
            dialog2: 'Traditional Surety Release',
            dialog3: 'Rental guarantee until delivery of keys (through successive renewals)',
            dialog4:
              'Full satisfaction of rent, i.e. payment of rent, charges' +
              '(Condominium, water, light, IPTU and piped gas), ' +
              'years to the property, contractual fines and interactive and external painting',
            dialog5: 'Tenants prior analysis',
            dialog6: 'Free legal assistance',
            dialog7: 'Automatic renewal guarantee',
            dialog8: 'Automatically generated bill',
          },
          additionalValues: {
            title: 'ADDITIONAL VALUES',
            subtitle:
              'The Values added when hiring the Bail Insurance will be paid by the Tenant ' +
              'and not by the owner of the property and will change the final value of your listing',
            rentValue: 'Rent Value',
            suretyRate: 'Bail Security Fee Included',
          },
        },
      },
    },
    reviewProperty: {
      buttonText: {
        buttonTextConfirm: 'Confirm and Publish',
      },
      errorText: 'An error occurred during announcement creation. ',
    },
  },
  help: {
    titleText: 'Help',
    subtitleText: 'Do you need any help? Did you find a problem? Talk to us :)',
    dropdownLabel: 'Choose a subject',
    dropdownText: {
      technicalProblemsText: 'Technical Problems',
      questionsText: 'Questions',
      criticismText: 'Criticism',
      suggestionsText: 'Suggestions',
      othersText: 'Others',
    },
    textAreaPlaceholder: 'Write here the reason for your contact',
    subjectAndBodyRequired: 'The subject and the body of the message are required.',
    contact: 'Get in touch',
    buttonText: 'Send',
  },
  login: {
    forgotPassword: {
      forgotText: 'Forgot Password',
      passwordNotFound: {
        notFoundFirstText: 'The email could not be found in our registrations',
        notFoundSecondText: 'Please check your email and try again',
      },
      passwordNotSet: {
        notSetFirstText: 'This account was created with Facebook and has no password set',
        notSetSecondText: 'Just sign in with Facebook to access it',
      },
      passwordTimeout: {
        timeOutFirstText: 'A new password request has already been made for the informed email',
        timeOutSecondText: 'Please wait 24 hours and try again',
      },
      logoText: 'mellro',
      recoverPassword: 'Recover password',
      subheadline: 'Enter your email to send a new password',
      askforNewPassword: 'Ask for new Password',
      doneEmailText: 'We send the new password to the above email. Please check your inbox.',
      doneChangePassword:
        "Once you've entered the app again, we suggest you change your password as soon as you can.",
      doneBackToLogin: 'Back to login screen',
    },
    signIn: {
      header: 'Login',
      logoText: 'mellro',
      welcomeText: 'Welcome Back',
      email: 'Email',
      password: 'Password',
      buttonText: 'Login',
      forgotPassword: 'Forgot my password',
      signUpText: 'Don’t have an account?',
      signUpLink: 'Create one here!',
    },
    signUp: {
      header: 'Sign Up',
      validationMessages: {
        passwordLength: 'A Senha deve ter no mínimo 8 caracteres.',
        passwordConfirm: 'A Senha e Confirmação de Senha não são iguais',
        emailConfirm: 'Já existe uma conta com o email informado',
      },
      labels: {
        name: 'Full Name',
        email: 'Email',
        cpf: 'CPF',
        password: 'Password',
        confirmPassword: 'Confirm Password',
      },
      logoText: 'mellro',
      createYourAcc: 'Create your account',
      subheadline: "Sign up to announce and find your property to rent. It's FREE!",
      buttonRegister: 'Register account',
    },
    home: {
      carousel: {
        title1: 'Welcome',
        text1: 'Rent or find your rental property.',
        title2: 'Find a place to call yours',
        text2: 'Rent a new home. Do it your way. Oh, did I mention its free?',
        title3: 'List your property for free',
        text3: 'Put your property in Mellro to find the ideal tenant.',
        title4: 'Know your tenant, know your landlord',
        text4: 'Its easy to know each other with Mellro and seal the deal!',
      },
      email: 'Login with Email',
      facebook: 'Login with Facebook',
      facebookLoginIssue:
        'We attempted communicating with Facebook but had no reply. ' +
        'Their services may be having issues, so please try again later and sorry for the inconvenience.',
      privacyPolicyText: 'By logging into Mellro you agree with our',
      privacyPolicyLink: 'Terms of Privacy',
    },
  },
  onboarding: {
    location: {
      headerText: 'Allow location',
      subheaderText: 'Sharing your location helps Mellro find better rental options for you.',
      discoverProperty: 'Discover nearby properties',
      yourLocation: 'Your location will be used to find properties near you.',
      footerTitle: 'Discover nearby properties',
      footerText: 'Your location will be used to find properties close to you.',
    },
    phoneValidation: {
      description: 'Inform your phone number',
      formPlaceholder: 'DDD + Number',
      invalidNumber: 'The informed phone number is either incomplete or invalid.',
      pinGenerationError:
        'There was an error with code generation. Please check your internet connection and ' +
        'try again in a few moments.',
      proceedButton: 'Generate Code',
    },
    pinValidation: {
      description: 'Please inform the code received via SMS',
      formPlaceholder: 'Insert the received code',
      pinValidationError: 'The informed PIN is invalid. Attempts remaining today: {{remaining}}',
      pinValidationException:
        'The informed PIN could not be validated at this time. Please check your internet ' +
        'connection and try again in a few moments.',
      resendButton: 'Resend Code',
      timeout: '(Available in {{resendTimeout}} seconds)',
      proceedButton: 'Validate Code',
    },
    whatYouLookFor: {
      header: {
        titleText: 'What are you looking for?',
        subtitleText:
          'Find your new home or find the ideal tenant for your property. ' +
          'Negotiate and close a good deal.',
      },
      wantToRent: {
        title: 'I want to find the ideal place to rent',
        button: 'Find rental property',
      },
      wantToAnnounce: {
        title: 'I want to announce my property for rent',
        button: 'Rent my property',
      },
    },
  },
  profile: {
    email: {
      verifiedHeader: 'E-mail Verified',
      verified: 'Your e-mail has been verified sucessfully!',
      continueToProfile: 'Continue to my Profile Page',
    },
    main: {
      bankDetails: 'Banking Details',
      bankTitle: 'Deposit Details',
      bankSubtitle: 'Inform deposit info to receive values',
      bank: 'Bank',
      branch: 'Bank Branch',
      cpfTitle: 'Register CPF',
      cpfSubtitle: 'This information is required to initiate negotiations and contracts',
      negotiationCPFRegister: `In order to start a negotiation with the property owner,
       we will need your registered CPF`,
      comingSoon: 'Coming Soon',
      whatsappNumber: '(Whatsapp Number)',
      tabs: {
        profile: 'Profile',
        settings: 'Settings',
      },
      socialMedia: 'Social Networks',
      socialMediaSubtitle: 'Check out your main social medias',
      locationDenied:
        'Permission to use location was denied. To see location of others and yourself, ' +
        'go to System preferences and enable this permission.',
      updatePhotoError: 'The photo could not be updated. Please try again later.',
      stateError: 'The phone number is incomplete/invalid.',
      errorText: 'An error occurred while changing Whatsapp number. Please try again later',
      dialogInputTitle: 'Enter your WhatsApp number with area code',
      announcementList: 'Announcements List',
      savedList: 'Liked List',
      configurationText: 'Configurations',
      contact: 'Contact',
      resetPassword: 'Reset Password',
      exitText: 'Exit',
    },
    bank: {
      errors: {
        invalidData: 'Invalid Bank Data',
      },
      bankTitle: 'Data for deposit',
      bankSubtitle: 'Enter your bank account details',
      bank: 'Bank',
      branch: 'Branch',
      accountType: 'Account Type',
      accountNumber: 'Account Number',
      checkingAccount: 'Checking Account',
      savingsAccount: 'Savings Account',
      validationMessages: {
        branchNumberLength: 'The agency number should contain a maximum of 4 characters.',
        missingAccountDigit: 'Insert a dash (-) to separate the account digit.',
        invalidAccountDigit: 'There must be only one account digit.',
      },
      bankPlaceholder: 'Enter your bank name',
      emptyResult: 'No result found',
    },
    cpf: {
      invalidCpf: 'Invalid CPF',
      cpf: 'CPF',
      cpfTitle: 'Register CPF',
      cpfSubtitle: 'A CPF is required to make negotiations, credit assessments and contracts.',
      validationMessages: {
        cpfLength: 'The CPF must have 11 characters',
      },
      saveAndContinue: 'Save and Continue',
    },
    resetPassword: {
      passwordMinimalCharacters: 'The password must be at least 8 characters long.',
      passwordConfirmText: 'Password and password confirmation are not the same.',
      cantChangePassword: 'Your password could not be changed. Please try again later.',
      header: {
        headline: 'Reset Password',
        subheadLine: 'Please enter your new password with a minimum of 8 characters.',
      },
      labels: {
        password: 'Password',
        confirmPassword: 'Confirm Password',
      },
      resetPassword: 'Reset Password',
      successChange: 'Password changed successfully!',
    },
    announcementList: {
      header: {
        titleText: 'My announcements',
        subtitleText: 'Here you will find a list of your advertised properties.',
      },
      errorText: 'An error occurred during announcements listing. ',
      emptyListText: "You haven't announced any property yet.",
      editAnnouncement: {
        errorText: 'An error occurred during announcement editing. ',
        confirmChanges: 'Confirm Changes',
        buttonText: 'Save Changes',
      },
      announcementItem: {
        seeAnnouncement: 'people saw this announcement',
        condominiumAndOthers: 'Condomimium and others',
        deleteAnnoucement: 'Delete announcement',
        editAnnouncement: 'Edit announcement',
        deleteAnnouncementAlert:
          'You are about to delete the announcement in {{address}}. Do you wish to continue?',
        visibilityText: 'Visible Announcement',
        interestedText: 'Interested',
        helper: {
          title: 'Approve or delete',
          content: 'By approving this tenant you will send an offer',
        },
      },
      notifications: {
        evaluationCredit: {
          headerNavigation: 'Credit rating',
          headerText: 'We are evaluating your credit',
          contentText: 'You will soon receive a notification informing you of this process',
          buttonText: 'See proposal',
        },
        profile: {
          headerNavigation: 'Profile Update',
          headerText: 'Choose a photo for your profile',
          contentText:
            'By adding a profile picture you can increase your chances of renting a property',
          buttonText: 'Select Now',
        },
        cellphone: {
          headerNavigation: 'Register your Cellphone',
          headerText: 'You do not have a cellphone registered yet!',
          contentText: 'To make a trade you need to register your cellphone',
          buttonText: 'Register Now',
        },
        interestPeople: {
          headerNavigation: 'Announcement Preview',
          headerText: 'People saw your ad!',
          headerSubTitle: 'Your ad seems to be getting a lot of attention!',
          contentText: 'People are interested in your property!',
          buttonText: 'View Interested',
        },
        privateCreditApproved: {
          headerNavigation: 'Credit rating',
          headerText: 'Approved Credit',
          subHeaderText: 'Approved Credit of',
          contentText: 'You can now finalize the negotiation with the Property',
          buttonText: 'See proposal',
        },
        proposeAcepted: {
          headerNavigation: 'Counterproposal',
          headerText: 'Your counter proposal has been accepted',
          subtitleContent: 'accepted your proposal',
          contentText: 'Now you can just wait',
          contentComplement: 'sign the contract',
          buttonText: 'See counterproposal',
        },
        counterproposal: {
          headerNavigation: 'Counterproposal',
          headerText: 'sent a counter proposal',
          subtitleContent: 'sent a counterproposal to you',
          contentText: 'You can evaluate it now, accept, decline or forward a new proposal!',
          buttonText: 'See counterproposal',
        },
      },
    },
    announcementMatch: {
      matchItem: {
        abandonTenantText:
          'You are about to abandon interest in the tenant {{tenantName}} ' +
          'for your property in {{address}}. ' +
          'Do you wish to continue?',
        closeDeal: 'Close Deal',
        contactTenant: 'Contact Tenant!',
        likeProfile: 'You like this profile!',
        deleteTenant: 'Delete Tenant',
        verifiedProfile: 'Verified profile',
        restore: 'Restore and Approve',
        dropout: '{{name}} gave up on the negotiation!',
      },
      matchList: {
        header: 'Interested',
        interestedSubtitle:
          'Here you will find a list of interested parties who liked this property ' +
          'and are waiting for your response.',
        refusedSubtitle:
          'Here you will find a list of people that liked this property ' +
          'but you refused their profile.',
        dropoutSubtitle:
          'Here you will find a list of people who liked this property but ' +
          'gave up before you answered them.',
        error: 'An error occurred in the listing/response of interested in this announcement. ',
        emptyLike: 'This property has not received likes yet.',
      },
      state: {
        matched: 'Profile Approved',
        waiting: 'Waiting for Approval',
        refused: 'Profile Refused',
        dropout: 'Dropout Profile',
      },
      tabs: {
        refused: 'Refused',
        interested: 'Interested',
        dropouts: 'Dropouts',
      },
      helper:
        'We sent an offer to {{name}} based on your conditions!\n You can change them anytime',
    },
    saved: {
      header: 'Liked',
      titleText: 'Liked',
      subtitleText: 'Check out the properties you like during your search in the Mellro catalogue.',
      errorText: 'An error occurred during the liked listing.',
      emptySavedAnnouncements: 'No liked announcements',
      savedList: {
        header: {
          headerTitle: 'Liked',
          headerSubTitle: 'All the properties you enjoyed are here!',
        },
        errorText: 'An error occurred during the liked listing. ',
        noLikedProperties: 'You haven’t liked any property yet.',
        noDislikedProperties: 'You haven’t discarded any property yet.',
      },
      savedItem: {
        informationText: 'Information',
        viewTheTenant:
          'Viewing the tenant profile is only possible when you are approved by him/her.',
        undoAlertText:
          'You are about to undo interest in the property in {{address}}.' +
          'Do you wish to continue? ',
        abandonAlertText:
          'You are about to abandon interest in the property in {{address}}. ' +
          'Do you wish to continue?',
        closeDealText: 'Close Deal',
        contactTenant: 'Contact Tenant!',
        approvedText: 'Your profile has been liked back!',
        abandonProperty: 'Discard Property',
        waitForApproval: 'Waiting Approval',
        waitingOwnerApproval: 'Awaiting the approval of the property owner',
        undoInterest: 'Undo Interest',
        goToAnnouncementDetails: 'View Property Details',
        approved: 'Approved',
        viewProfile: 'View Landlord Profile',
        condominiumAndOthers: 'Condominium & Others',
      },
      dislikedItem: {
        restore: 'Restore property',
      },
      tab: {
        saved: 'Liked',
        discarded: 'Discarded',
      },
    },
    userAnnouncement: {
      titleText: 'My Announcements',
      subtitleText: 'Check out their advertised properties for rent.',
      errorText: 'There was an error during listings your announcements',
      emptyAnnouncement: 'No annoucements from you',
    },
    negotiation: {
      titleText: 'Contract conditions',
      subtitle: 'Set the conditions for your property rental',
      receivedProposal: {
        title: 'Received proposal',
        content: 'You received a proposal from {{name}} and you can accept it or send a new one',
      },
      status: {
        approved: {
          header: 'Approved proposal',
          message: `{{name}} approved the proposal sent to him, now all
          that's left is to close the deal and sign the contract`,
        },
        returned: {
          header: 'Counter proposal',
          message: '{{name}} made a counter proposal',
        },
        declined: {
          header: 'Denied credit',
          message: '{{name}} had the credit evaluation denied for this offer',
        },
        pending: {
          header: 'Credit evaluation pendent',
          message: 'We are waiting for the result of the credit evaluation of {{name}}',
        },
        sentProposal: {
          header: 'Proposal sent',
          message: `You sent the announced proposal to {{name}}
          and we are waiting for a response. You can change the proposal whenever you want`,
        },
        counterProposal: {
          received: {
            header: 'Counterproposal received',
            message: `You received a counterproposal from {{name}}.
            You can accept or submit a new proposal`,
          },
          sent: {
            header: 'Counterproposal sent',
            message: `You sent a counterproposal to {{name}} and we are waiting for an answer.
            you can change the proposal whenever you want`,
          },
        },
        counterProposalSent: `You sent a counter proposal to {{name}}
        and we are awaiting for the answer. You can change the proposal whenever you want.`,
      },
      warrantyTexts: {
        noGuarantorNeeded: 'Does not need guarantor',
        boletoPayment: 'Payment with boleto',
      },
      conditions: {
        valuesAndMaturitiy: {
          title: 'Values and maturities',
          description: 'All the values and maturities can be seen here',
          changeValue: 'Change value',
        },
        itemsValue: 'Rent + maintenance fee + IPTU + Others',
        dueDate: {
          title: 'Due date',
          content: {
            withDate: 'Due date: {{number}}',
            withoutDate: '{{number}} days after sign',
          },
          changeDueDate: 'Change due date',
          confirm: 'Confirm due date',
          define: 'Define condominium due date',
          save: 'Save due date',
        },
        paymentAndWarranty: {
          title: 'Warranty and payment model',
          content: "You're the only one able to change your warranty and payment methods",
          changeWarranty: 'Change warranty',
        },
      },
      contract: {
        duration: {
          title: 'Contract duration',
          content:
            'automatic renewal and annual readjustment by IGPM. 10% penalty of remaining duration',
          time: '{{number}}\nYear',
        },
        contract: 'Proceed with contract',
        newProposal: 'Send new proposal',
      },
    },
    registerCPF: {
      titleText: 'Register CPF',
      registerPage: {
        titleText: 'Register your cpf',
        content: 'To start negotiating with interested parties we will need your CPF!',
        buttonLabel: 'Register now',
      },
      validationMessages: {
        length: 'CPF Inválido',
      },
    },
    dueDate: {
      titleText: 'Due date',
    },
    creditEvaluation: {
      ownerView: {
        approved: '{{name}} had the credit approved for this offer',
        denied: '{{name}} had the credit declined for this offer',
        evaluating: 'We are evaluating the credit of {{name}} for this offer',
        pending: 'We are awaiting for {{name}} to inform its cpf for the credit evaluation',
      },
      tenantView: {
        denied: {
          title: 'Credit denied',
          message: 'Your credit evaluation has not been approved! Talk to {{name}} to renegotiate',
        },
      },
    },
    settings: {
      header: {
        headline: 'Change Password',
        subheadLine: 'Change your login password',
      },
      currentPasswordDisclaimer:
        'Current password is only required if you created your account without ' +
        'facebook login or have previously defined a password.',
      labels: {
        currentPassword: 'Current password',
        newPassword: 'New password',
        confirmPassword: 'Repeat new password',
      },
      placeholders: {
        currentPassword: 'Insert your current password here',
        newPassword: 'Insert the new password here',
        confirmPassword: 'Insert the old password here',
      },
      errors: {
        cantChangePassword:
          'Your password could not be changed. Please check if you need to inform the ' +
          'current password and if it was typed correctly and try again.',
      },
      formValidations: {
        passwordConfirmText: 'Password and password confirmation are not the same',
        passwordMinimalCharacters: 'All passwords must be at least 8 characters long.',
      },
      notifications: {
        header: {
          headline: 'Notification options',
          subheadLine: 'Select your options bellow.',
        },
        labels: {
          push: 'Push',
          email: 'E-mail',
          submit: 'Save changes',
        },
        errors: {
          settingsUnchanged: 'No notification changes to save',
          cantUpdateNotifications:
            'Your notification settings could not be changed. Please try again later.',
        },
        successSave: 'Notification preferences liked successfully!',
      },
    },
  },
  manage: {
    notifications: {
      payment: {
        paid: {
          title: "{{month}}'s rent paid",
          topText: "{{name}} paid {{month}}'s rent!",
          bottomText:
            "We already checked the payment in our systems, and we'll send it to your bank account in 24H!",
          button: 'See payment',
        },
        confirmed: {
          title: "{{month}}'s rent paid",
          automatic: {
            topText: 'Your payment was successful!',
            bottomText: 'Our system detected your payment!',
          },
          manual: {
            topText: '{{owner}} confirmed the rent payment!',
            bottomText: 'You can see the voucher and confirm the payment on the manage screen!',
          },
          button: 'See payment',
        },
        late: {
          title: "{{month}}'s rent late",
          landlord: {
            topText: "{{name}} is {{days}} work days late on {{month}}'s rent!",
            bottomText:
              'We already notified {{name}} about this late payment, with the recalculated value!',
            automatic:
              "\n\nIf the payment is not done in 20 days, we'll altomatically trigger the bail insurance!",
            manual: '',
            button: 'See parcel',
          },
          tenant: {
            topText: "{{name}}, you are {{days}} work days late on {{month}}'s rent!",
            bottomText: 'We already notified {{owner}} about this late payment!',
            automatic:
              "If you're unable to pay in 20 days, we'll altomatically trigger the bail insurance!",
            manual: 'You can generate a ticket with the recalculated value bellow!',
            button: 'See parcel',
          },
        },
        close: {
          title: "{{month}}'s rent is due soon",
          topText: "The rent of {{month}} is close to it's due date: {{date}}",
          bottomText: 'Keep your payments up to date!',
          button: 'See payment',
        },
        denied: {
          title: 'Payment not confirmed',
          topText: '{{owner}} denied your payment!',
          bottomText: 'Send your voucher again!',
          button: 'Go to parcel',
        },
      },
      securityDeposit: {
        paid: {
          title: 'The Security Deposit has been done!',
          topText: '{{name}} has done the security deposit! ',
          bottomText: "Confirm {{name}}'s payment! ",
          button: 'Confirm payment',
        },
        denied: {
          title: "We still haven't identified your security deposit",
          bottomText: 'The security deposit is required for the delivery of the keys! ',
          button: 'Confirm deposit',
        },
        entry: 'Security deposit',
        number: {
          title: 'Number of security deposits',
          content: 'Select how many security deposits equate the rent value',
          options: {
            withSingleSecurityDeposit: '{{number}} month - R$ {{value}}',
            withSecurityDeposit: '{{number}} month - R$ {{value}}',
            withoutSecurityDeposit: 'Without security deposit',
          },
        },
        confirm: 'Confirm and continue',
      },
    },
    title: 'Manage',
    subtitleText: 'Track payments, make charges.',
    checkOut: 'Check Out',
    inactiveMonth: 'Contract is not active on this month!',
    payment: {
      state: {
        paid: 'Paid',
        open: 'Open',
        late: 'Late',
      },
      name: {
        rent: 'Rent',
        condo: 'Condomium',
        iptu: 'IPTU',
        others: 'Others',
      },
      info: {
        paidOn: 'Paid on: {{date}}',
        nextDue: 'Next due: {{date}}',
        paymentMode: 'Payment mode: ',
        paymentModeValue: {
          money: 'Money',
        },
        discount: 'Discount:',
      },
      discount: {
        title: 'Discount Amount',
        text: "You'll give this discount in the next installment!",
        valuePlaceholder: 'Insert the discount amount',
        reasonPlaceholder: 'Insert a reason for the discount',
        warning: {
          greaterThanZero: 'Discount value should be greater than zero!',
          lessThanPrice: 'Discount value should be less than {{price}}',
        },
      },
      lateWarning: {
        title: 'Late Payments!',
        text: 'We send daily notifications to {{name}}',
      },
      buttons: {
        discount: 'Discount on price',
        applyDiscount: 'Apply discount',
        checkVoucher: 'Check voucher',
        approvePayment: 'Approve payment',
        discardPayment: 'Discard payment',
        undoApproval: 'Undo Approval',
        paymentApproved: 'Payment approved',
        download: 'Download Payment Slip',
        sendToEmail: 'Send to e-mail',
        copyCode: 'Copy payment slip code',
        paid: 'I already paid',
        sendVoucher: 'Send voucher',
      },
      voucher: 'Voucher',
    },
  },
  rent: {
    details: {
      savedText:
        "You've added this announcement to your liked list! \n" +
        "Now just wait for the owner's approval to proceed.",
      textButton: 'Return To Catalog',
    },
    filters: {
      header: 'Filters',
      discardedSection: {
        title: 'Discarded Properties',
        text:
          "When you discard a property it goes to your discarded properties list. But don't " +
          'worry, you can restore them!',
        button: 'Restore discarded properties',
      },
      locationSection: {
        title: 'Location',
        text:
          'Find the properties of your dreams by searching by address, city, neighborhood or directly on the map!',
        subtitle: 'Search by Address',
        autocomplete: 'Insert the Neighborhood, City or Address',
      },
      petSection: {
        title: 'Pet Policy',
        allowed: 'Allowed',
        indifferent: 'Indifferent',
      },
      sectionTitle: 'Location',
      valuesText: 'Values',
      rentValueText: 'Rent Value',
      rentValue: 'between {{min}} and {{max}}',
      valueType: {
        rent: 'Rent',
        total: 'Total',
      },
      distance: 'Maximum distance - {{distance}}km',
      minimalValue: 'Maximum Values',
      maxValue: 'Maximum',
      propertyInformation: {
        alertText:
          'Permission to use location was denied. To use the proximity filter, go to ' +
          'System preferences and enable this permission.',
        propertyInformationText: 'Property Information',
        roomText: 'Room (s)',
        bathroomText: 'Bathroom (s)',
        carSlotsText: 'Car Slot (s)',
        dontMatterText: "Don't Matter",
      },
      totalArea: 'Total area of the Property',
      totalAreaValue: 'between {{min}}m² and {{max}}m²',
      propertyDetail: 'Property Details',
      condominiumDetail: 'Condominium Details',
      resetFilters: 'Reset Filters',
      textButton: 'Apply Filters',
      propertyTypes: 'Property Types',
    },
    catalog: {
      header: 'Rent',
      filters: 'Filters',
      liked: 'Liked',
      undo: 'Undo',
      tabs: {
        map: 'Map',
        list: 'List',
        cards: 'Cards',
      },
      emptyDeck: {
        noMatchText: 'Sorry, it was not possible to find any property at the moment.',
        notificationAlert:
          'You will be alerted in your notifications ' +
          'when properties with features you want appear in your search radar',
        changeFilters: 'Change filters',
        undoDiscard: 'Undo Discarded Properties',
        noMatchTryAgain:
          'Try cleaning/changing the current filters and if you still get no results, ' +
          'you can undo previously discarted properties below.',
        cleanFilters: 'Clean Filters',
      },
      cards: {
        additionalTaxes: 'Additional Taxes',
        info: {
          house: 'House',
          apartment: 'Apt',
          studio: 'Studio',
          type: 'Type',
          area: 'Area',
          bathrooms: 'Bths',
          rooms: 'Rooms',
          carSlots: 'Car Slots',
          details: '+ Details',
        },
      },
      map: {
        alertText:
          'Permission to use location was denied. To enhance your catalog map experience, go to ' +
          'System preferences and enable this permission.',
      },
    },
    notifications: {
      header: 'Notifications',
      tabs: {
        recent: 'Recent',
        properties: 'Properties',
        like: 'Likes',
      },
      like: {
        title: '{{name}} liked your property!',
        message: "Now you can see or approve {{name}}'s profile.",
        approveProfile: 'Approve Profile',
      },
      match: {
        landlordTitle: 'You approved {{name}}!',
        tenantTitle: '{{name}} approved your profile',
        message: 'Now you can contact {{name}}, or see their profile.',
      },
      alreadyRented: {
        title: 'Oh, Too bad!',
        subtitle: "{{name}}'s property has already been rented!",
        message: "But don't worry, you can find many other properties in our catalog!",
        goToCatalog: 'Go to catalog',
      },
      counterProposal: {
        title: '{{name}} made a counter-proposal',
        message: '{{name}} sent a counter-proposal for you!',
        questions: 'Ask questions',
        seeProposal: 'See proposal',
        undoInterest: 'Undo interest',
      },
      receivedOffer: {
        title: 'Received offer',
        message: '{{name}} approved your profile and sent you an offer!',
      },
      ownerApprovedProfile: {
        title: '{{name}} approved your profile!',
        message: '{{name}} sent a proposal and you can negotiate or ask questions.',
        questions: 'Ask questions',
        seeProposal: 'See proposal',
        undoInterest: 'Undo interest',
      },
      undoneInterest: {
        title: '{{name}} has undone the interest of your property',
        message:
          'It seems {{name}} is no longer interested in your property. ' +
          'No problem, others will come quickly, you can be sure!',
        seeInterested: 'See interested',
      },
      interestedTenant: {
        title: '{{name}} is interested in your property!',
        title2: '{{name}} is waiting for you!',
        message:
          "Now you can approve {{name}}'s profile, view the profile or delete the interested.",
        message2: '{{name}} liked your property yesterday and is waiting for your approval!',
        approveProfile: 'Approve Profile',
        deleteInterested: 'Delete interested',
      },
    },
  },
  contract: {
    header: 'Contract',
    type: {
      depositBond: 'DEPOSIT BOND',
      insuranceBond: 'INSURANCE BOND',
    },
    buttons: {
      readContract: 'Read Contract',
      manage: 'Manage',
      terminateContract: 'Terminate Contract',
      createContract: 'Create Contract',
    },
    contractMain: {
      title: 'Review the contract before signing',
      contractParties: 'Parties to the contract',
      signAsLandlord: 'Sign as landlord',
      signAsTenant: 'Sign as tenant',
      dueDateMonth: '{{dueDate}}/every month',
      paymentType: {
        cashPayment: 'CASH PAYMENT',
        billPayment: 'BILL PAYMENT',
      },
      negotiatedConditions: {
        title: 'Negotiated Conditions',
        aboveConditions: 'Below are all the conditions negotiated and added to your contract',
        value: 'About {{value}} monthly',
        landlordPays: 'Landlord pays',
      },
      isuranceModel: {
        title: 'Isurance and payment model',
        moneyPayment: 'Cash Payment',
        billetPayment: 'Payment in billet',
      },
      contractDuration: {
        title: 'Contract duration',
        subtitle: 'Automatic renewal and annual readjustment by',
        subtitle2: 'Fine of 10% of the remaining duration.',
        bottomText: "We'll forward the signed contract to all parties.",
        contractDuration: '{{count}} meses',
      },
    },
    notification: {
      header: 'Sign Contract',
      ready: {
        title: 'Your contract is ready',
        topText: 'Your Lease Agreement is ready to be signed!',
        bottomText: "You'll receive an e-mail to sign the lease.",
        button: 'Help',
      },
      signed: {
        title: 'All parties have signed the lease',
        topText: 'You and {{name}} have already signed the lease!',
        bottomText:
          'Now you just need to wait for the security deposit to deliver the keys and start managing!',
        button: 'Manage',
      },
    },
  },
}
